import React from "react";
import AllSubjectTopics from "../../topics/AllSubjectTopics";


function ToperNoteChemTopics() {
  return (
    <>

      <AllSubjectTopics  subject="chemistry" type="topernote" />


    </>
  );
}

export default ToperNoteChemTopics;